<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="pt"><a class="page" id="page.36"></a><a class="page" id="page.37"></a>The Epistle to the<br/>ROMANS</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eernicnt66ro0010.vue?9e2bde72